'use client';

import { CenteredPageLayout } from '@/layout/CenteredPageLayout';
import { ManagementCards } from './ManagementCards';
import { DiscussManagingPropertiesForm } from './DiscussManagingPropertiesForm';

export default function ManagementPage() {
  return (
    <CenteredPageLayout title="PROPERTY MANAGEMENT">
      <div className="space-y-12">
        <ManagementCards />
        <DiscussManagingPropertiesForm />
      </div>
    </CenteredPageLayout>
  );
}
